module.exports = __webpack_public_path__ + "img/ubank.7ce1f314.jpg";